import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { DialogCloseResult, DialogService } from "@progress/kendo-angular-dialog";
import * as fromStore from '@src/app/store/conventional';
import { catchError, throwError } from "rxjs";

export const unauthenticatedInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store<fromStore.State>);
  const dialogService = inject(DialogService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const dialogRef = dialogService.open({
          title: "Warning",
          content: "Login failed. Please check your credentials.",
          cssClass: 'logged-out-dialog',
        });

        dialogRef.result.subscribe((result) => {
          if (result instanceof DialogCloseResult) {
            store.dispatch(fromStore.logoutConfirmed());
          }
        });

        setTimeout(() => {
          store.dispatch(fromStore.logoutConfirmed());
        }, 4000);
      }

      return throwError(() => error);
    }),
  );
};